import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { useUserExperience } from "../../../User/api/queries/useUserExperience";

import { ExperienceLoader } from "./ExperienceLoader";
import { EmptyExperience } from "./EmptyExperience";
import { ExperienceItem } from "./ExperienceItem";

import { styles } from "./styles";

const Experience = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "experience" });
  const { userId } = useParams<{ userId: string }>();

  const {
    data: experienceData,
    isLoading: isExperienceLoading,
    isError: isExperienceError,
  } = useUserExperience(userId ?? "");

  if (isExperienceLoading) return <ExperienceLoader />;
  if (isExperienceError || !experienceData?.items) return <EmptyExperience />;

  const { CLUB = [], NATIONAL = [] } = experienceData.items;

  if (CLUB.length === 0 && NATIONAL.length === 0) return <EmptyExperience />;

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("experience")}</Typography>
      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "16px" }}>
        {CLUB.length > 0 && (
          <>
            <Typography sx={styles.sectionTitle}>{t("career")}</Typography>
            {CLUB.map((experience) => (
              <ExperienceItem key={experience.id} experience={experience} />
            ))}
          </>
        )}

        {NATIONAL.length > 0 && (
          <>
            <Typography sx={styles.sectionTitle}>{t("nationalTeam")}</Typography>
            {NATIONAL.map((experience) => (
              <ExperienceItem key={experience.id} experience={experience} />
            ))}
          </>
        )}
      </Box>
    </Box>
  );
};

export default Experience;
